function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { THREEDS_METHOD_TIMEOUT } from './threeds2utilities/config';
import base64URL from './threeds2utilities/base64url';
import createForm from './threeds2utilities/form';
import createIframe from './threeds2utilities/iframe';
var at3DSMethodNotificationUrlResolvedFn;
var checkInterval;
var methodUrlTimeout;
export var getThreeDSCompInd = (_ref, iframeContainer) => {
  var {
    threedsMethodNotificationURL,
    methodURL,
    serverTransactionID,
    API
  } = _ref;
  var resolveData = {
    threeDSCompInd: 'U'
  };
  var createMethodFrame = new Promise(function (resolve) {
    if (methodURL || methodURL.length) {
      // 1. Create and Base64Url encode a JSON object containing the serverTransactionID & threeDSMethodNotificationURL
      var dataObj = {
        threeDSServerTransID: serverTransactionID,
        threeDSMethodNotificationURL: threedsMethodNotificationURL
      };
      var jsonStr = JSON.stringify(dataObj);
      var base64URLencodedData = base64URL.encode(jsonStr);
      /**
       * Appends and submits a form in the created iframe
       */

      var appendAndSubmitForm = iframe => {
        function messageHandler(event) {
          if (API.startsWith(event.origin)) {
            var _event$data;

            resolve({
              threeDSCompInd: (_event$data = event.data) == null ? void 0 : _event$data.threeDSCompInd
            });
            window.removeEventListener('message', messageHandler);
          }
        }

        window.addEventListener('message', messageHandler);
        var form = createForm('threedsMethodForm', methodURL, 'threeDSMethodIframe', 'threeDSMethodData', base64URLencodedData);
        iframe.appendChild(form);
        form.submit();
        return iframe.contentWindow;
      };
      /**
       * Creates iframe, then appends and submits form
       */


      var createIframeAndAppendForm = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* () {
          var iframe = createIframe(iframeContainer, 'threeDSMethodIframe', '0', '0');
          var iframeCW = appendAndSubmitForm(iframe);
          var at3DSMethodNotificationUrl = new Promise(function (resolve) {
            at3DSMethodNotificationUrlResolvedFn = resolve;
          });
          var at3DSMethodNotificationUrlData = yield at3DSMethodNotificationUrl;
          resolveData.threeDSCompInd = at3DSMethodNotificationUrlData;
          resolveData.iframeConfig = {
            container: iframeContainer
          };
          return iframeCW;
        });

        return function createIframeAndAppendForm() {
          return _ref2.apply(this, arguments);
        };
      }();

      createIframeAndAppendForm();
    }
  });
  var promiseTimeout = new Promise(resolve => {
    methodUrlTimeout = setTimeout(() => {
      resolveData.threeDSCompInd = 'N';
      resolve({
        threeDSCompInd: resolveData.threeDSCompInd
      }); // resolve promiseTimeout Promise

      clearInterval(checkInterval);
    }, THREEDS_METHOD_TIMEOUT);
  }); // Promise.race settles when the first one of these promises settles (one is a timeout based promise the other is the createIframe promise)
  // It resolves/rejects with the value received from the settled promise

  var p = Promise.race([createMethodFrame, promiseTimeout]);
  return p;
};
//# sourceMappingURL=get-3ds-comp-ind.js.map